/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';

import { PanelComponent } from './panel.component';

@Directive({
  selector: '[ghPanelTriggerFor]',
})
export class PanelTriggerForDirective implements OnDestroy {
  @Input() ghPanelTriggerFor: PanelComponent;

  constructor(private elementRef: ElementRef) {

  }

  ngOnDestroy(): void {
    this.ghPanelTriggerFor.close();
  }

  @HostListener('click')
  openMenu(): void {
    this.ghPanelTriggerFor.open(new CdkOverlayOrigin(this.elementRef));
  }
}
